import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { EllipsisVertical } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';
import { ActionIconButton } from '@/shared/components/action-icon-button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';

interface ListCardActionsProps {
  menuChildren: ReactNode;
  viewLabel?: string;
  viewIcon?: LucideIcon;
  onView?: (e: React.MouseEvent) => void;
  /** Esconde o botão de olho abaixo do breakpoint (desktop permanece). */
  hideViewBelow?: 'sm' | 'md';
  /** Botão principal antes do ⋯, que fica no fim da linha. */
  viewFirst?: boolean;
}

/** Menu ⋯ + botão de visualização opcional — padrão Leads / Clientes / Produtos. */
export function ListCardActions({
  menuChildren,
  viewLabel,
  viewIcon: ViewIcon,
  onView,
  hideViewBelow,
  viewFirst = false,
}: ListCardActionsProps) {
  const showView = Boolean(onView && viewLabel && ViewIcon);

  return (
    <div className={cn('flex items-center gap-1.5', viewFirst && 'flex-row-reverse')}>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            variant="outline"
            size="icon"
            aria-label="Mais ações"
            className="size-10 rounded-lg border-border/60 bg-background/60 shadow-sm transition-all hover:border-primary/30 hover:bg-accent/80"
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
          >
            <EllipsisVertical className="size-4 text-muted-foreground" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          side="bottom"
          sideOffset={4}
          collisionPadding={12}
          onClick={(e) => e.stopPropagation()}
        >
          {menuChildren}
        </DropdownMenuContent>
      </DropdownMenu>

      {showView && ViewIcon && onView && viewLabel ? (
        <div
          className={cn(
            hideViewBelow === 'sm' && 'hidden sm:block',
            hideViewBelow === 'md' && 'hidden md:block',
          )}
        >
          <ActionIconButton
            label={viewLabel}
            className="text-muted-foreground hover:text-primary"
            onClick={onView}
          >
            <ViewIcon className="size-4" />
          </ActionIconButton>
        </div>
      ) : null}
    </div>
  );
}
